<template>
    <div class="time-range-slider">
        <div class="time-range-slider__inputs">
            <el-input 
                :value="value ? value[0].format('HH:mm:ss') : undefined"
                v-mask="'##:##:##'"
                @blur="onInputBlur(0, $event)"
                v-on:keyup.enter.native="onInputBlur(0, $event)"
                :key="`from_${version}`"
            >
                <template slot="prepend">
                    <el-button 
                        icon="el-icon-minus" 
                        @mousedown.native="onStepMouseDown(0, -1)"
                        @mouseup.native="onStepMouseUp"
                        @mouseleave.native="onStepMouseUp"
                    >
                    </el-button>
                </template>
                <template slot="append">
                    <el-button 
                        icon="el-icon-plus" 
                        @mousedown.native="onStepMouseDown(0, 1)"
                        @mouseup.native="onStepMouseUp"
                        @mouseleave.native="onStepMouseUp"
                    >
                    </el-button>
                </template>
            </el-input>
            <el-input 
                :value="value ? value[1].format('HH:mm:ss') : undefined"
                v-mask="'##:##:##'"
                @blur="onInputBlur(1, $event)"
                v-on:keyup.enter.native="onInputBlur(1, $event)"
                :key="`to_${version}`"
            >
                <template slot="prepend">
                    <el-button 
                        icon="el-icon-minus" 
                        @mousedown.native="onStepMouseDown(1, -1)"
                        @mouseup.native="onStepMouseUp"
                        @mouseleave.native="onStepMouseUp"
                    >
                    </el-button>
                </template>
                <template slot="append">
                    <el-button 
                        icon="el-icon-plus" 
                        @mousedown.native="onStepMouseDown(1, 1)"
                        @mouseup.native="onStepMouseUp"
                        @mouseleave.native="onStepMouseUp"
                    >
                    </el-button>
                </template>
            </el-input>
        </div>
        <el-slider
            :value="unixRange"
            :min="min.unix()"
            :max="max.unix()"
            :step="adjustedStep"
            range
            :format-tooltip="formatUnix"
            @input="onInput"
        />
    </div>
</template>

<style lang="scss">
    .time-range-slider {
        &__inputs {
            display: flex;
            justify-content: space-between;
            .el-input {
                max-width: 210px;
                &.is-disabled .el-input__inner {
                    background-color: white;
                    color: black;
                    cursor: text;
                }
            }
        }
    }
</style>

<script>
import moment from 'moment';
import {mask} from 'vue-the-mask'

export default {
    directives: {mask},
    props: {
        value: {
            validator: x => Array.isArray(x) && x.length === 2 && moment.isMoment(x[0]) && moment.isMoment(x[1])
        },
        min: {
            required: true,
            validator: x => moment.isMoment(x)
        },
        max: {
            required: true,
            validator: x => moment.isMoment(x)
        },
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            stepTimeout: undefined,
            stepInterval: undefined,
            version: 0
        }
    },
    computed: {
        unixRange() {
            return this.value ? [this.value[0].unix(), this.value[1].unix()] : undefined;
        },
        adjustedStep() {
            const maxStep = this.max.unix() - this.min.unix();
            return Math.min(this.step, maxStep);
        }
    },
    watch: {
        value() {
            this.version += 1; 
            if(!Number.isFinite(this.version)) this.version = 0;
        }
    },
    methods: {
        formatUnix(value) {
            return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
        },
        onInput(value) {
            this.$emit('input', [moment.unix(value[0]), moment.unix(value[1])]);
        },
        onStepMouseDown(index, sign) {
            if(!this.value) return;
            const applyStep = () => {
                const newValue = [this.value[0], this.value[1]];
                newValue[index] = moment(newValue[index]).add(this.adjustedStep * sign, 'second');
                if(newValue[0].isAfter(newValue[1])) newValue[0] = moment(newValue[1]);
                if(newValue[1].isBefore(newValue[0])) newValue[1] = moment(newValue[0]);
                this.$emit('input', newValue);
            };
            applyStep();
            this.stepTimeout = setTimeout(() => {
                this.stepInterval = setInterval(applyStep, 150);
            }, 200);
        },
        onStepMouseUp() {
            clearTimeout(this.stepTimeout);
            clearInterval(this.stepInterval);
        },
        onInputBlur(index, event) {
            if(!this.value) {
                event.target.value = '';
                return;
            }
            const val = (event.target.value).split(':');
            val[0] = (val[0] || '').padEnd(2, '0');
            val[1] = (val[1] || '').padEnd(2, '0');
            val[2] = (val[2] || '').padEnd(2, '0');
            const str = val[0] + ':' + val[1] + ':' + val[2]; 

            let value = moment(this.value[index].format('YYYY-MM-DD') + ' ' + str, 'YYYY-MM-DD HH:mm:ss', true)
            let valid = value.isValid();
            if(valid) {
                if(value.isBefore(this.min)) {
                    value = moment(this.max.format('YYYY-MM-DD') + ' ' + str, 'YYYY-MM-DD HH:mm:ss', true);
                    valid = !value.isAfter(this.max);
                }
                else if(value.isAfter(this.max)) {
                    value = moment(this.min.format('YYYY-MM-DD') + ' ' + str, 'YYYY-MM-DD HH:mm:ss', true);
                    valid = !value.isBefore(this.min);
                }
            }
            const newValue = [this.value[0], this.value[1]];
            newValue[index] = valid ? value : newValue[index];
            if(newValue[0].isAfter(newValue[1])) newValue[0] = moment(newValue[1]);
            if(newValue[1].isBefore(newValue[0])) newValue[1] = moment(newValue[0]);
            this.$emit('input', newValue);    
        }
    }
}
</script>


// WEBPACK FOOTER //
// TimeRangeSlider.vue?63e2e96e